import SuppliersTask from "@/components/suppliers/task/Task";
import ArchiveList from "@/components/suppliers/archiveList/ArchiveList";
import ExcludedSites from "@/components/suppliers/excludedSites/ExcludedSites";
import Keys from "@/components/suppliers/keys/Keys";
import TaskList from "@/components/suppliers/taskList/TaskList";
import StopWords from "@/components/suppliers/stopWords/StopWords";
import ViewTask from "@/components/suppliers/viewTask/ViewTask";

export const suppliers = [
    {path: '/suppliers/task', name: 'suppliers', component: SuppliersTask},
    {path: '/suppliers/task-list', name: 'suppliersTaskList', component: TaskList},
    {path: '/suppliers/archive-list', name: 'suppliersArchiveList', component: ArchiveList},
    {path: '/suppliers/keys', name: 'suppliersKeys', component: Keys},
    {path: '/suppliers/stop-words', name: 'suppliersStopWords', component: StopWords},
    {path: '/suppliers/excluded-sites', name: 'suppliersExcludedSites', component: ExcludedSites},
    {path: '/suppliers/view-task/:id', name: 'suppliersViewTask', component: ViewTask},
]